import React, { useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { apiUrl } from "../config/Config";
import logo from "../assets/images/omsagalogo-removebg-preview.webp";
const loadRazorpay = () => {
  if (window.Razorpay) return Promise.resolve(true);

  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const PhaseTwoSevaModal = ({ show, user, onContinue, onPaymentSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const contribute = async () => {
    setLoading(true);
    setError("");

    try {
      const sdkLoaded = await loadRazorpay();
      if (!sdkLoaded) {
        throw new Error("Razorpay could not be loaded. Please check your connection.");
      }

      const { data } = await axios.post(
        apiUrl + "create-phase-two-seva-order",
        {},
        { headers: { Authorization: "Bearer " + user?.token } }
      );

      if (data?.status !== "success") {
        throw new Error(data?.message || "Unable to start the payment.");
      }

      const razorpay = new window.Razorpay({
        key: data.key,
        amount: data.amount * 100,
        currency: data.currency,
        name: "TheOmSaga",
        description: "Phase 2 Seva",
        order_id: data.order_id,
        handler: async (response) => {
          try {
            const verification = await axios.post(
              apiUrl + "confirm-phase-two-seva-payment",
              {
                paymentid: response.razorpay_payment_id,
                orderid: response.razorpay_order_id,
                signature: response.razorpay_signature,
              },
              { headers: { Authorization: "Bearer " + user?.token } }
            );

            if (verification.data?.status !== "success") {
              throw new Error(verification.data?.message || "Payment verification failed.");
            }

            onPaymentSuccess();
          } catch (verificationError) {
            setError(
              verificationError.response?.data?.message ||
                verificationError.message ||
                "Payment verification failed. Please contact support."
            );
          } finally {
            setLoading(false);
          }
        },
        modal: {
          ondismiss: () => setLoading(false),
        },
        prefill: {
          name: user?.fullname || "",
          email: user?.email || "",
          contact: user?.number || "",
        },
        theme: { color: "#9b4819" },
      });

      razorpay.on("payment.failed", (response) => {
        setError(response.error?.description || "Payment failed. Please try again.");
        setLoading(false);
      });
      razorpay.open();
    } catch (paymentError) {
      setError(
        paymentError.response?.data?.message ||
          paymentError.message ||
          "Unable to start the payment. Please try again."
      );
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onContinue}
      centered
      backdrop="static"
      keyboard={!loading}
      className="phase-two-seva-modal"
    >
      <button
        type="button"
        className="phase-two-seva-close"
        aria-label="Continue without contributing"
        onClick={onContinue}
        disabled={loading}
      >
        &times;
      </button>

      <Modal.Body>
        <div className="phase-two-seva-symbol" aria-hidden="true"> <img
              src={logo}
              alt="Logo"
              className=""
              loading="eager" // This tells the browser to load it immediately
              decoding="async"
            /></div>
        {/* <p className="phase-two-seva-kicker">A heartfelt invitation</p> */}
        <h2>You’re already registered for a lifetime!</h2>
        <p className="phase-two-seva-message">
      If you’d like to be a part of Phase 2, simply click the Contribute button. 
Otherwise, you’re welcome to continue Reading & Writing Stories.
        </p>

        <div className="phase-two-seva-amount">
          <span>Phase 2 Seva</span>
          <strong>₹99</strong>
        </div>

        {error && <p className="phase-two-seva-error" role="alert">{error}</p>}

        <button
          type="button"
          className="phase-two-seva-pay"
          onClick={contribute}
          disabled={loading}
        >
          {loading ? "Opening secure payment…" : "Contribute ₹99"}
        </button>
        <button
          type="button"
          className="phase-two-seva-continue"
          onClick={onContinue}
          disabled={loading}
        >
          Continue to Stories
        </button>
        <p className="phase-two-seva-secure">Secure payment powered by Razorpay</p>
      </Modal.Body>
    </Modal>
  );
};

export default PhaseTwoSevaModal;
